export default [
  {
    key: 'basic',
    title: '基础信息管理',
    children: [
      {
        key: '/keywords/profile',
        title: '个人设置',
      },
      {
        key: '/keywords/users',
        title: '用户管理',
      },
      {
        key: '/keywords/directors',
        title: '团长管理',
      },
      {
        key: '/keywords/bloggers',
        title: '博主管理',
      },
    ]
  }, 
  {
    key: 'platformOperate',
    title: '平台运营',
    children: [
      {
        key: '/keywords/banner',
        title: '首页Banner管理',
      },
      {
        key: '/keywords/popups',
        title: '弹窗管理',
      },
      {
        key: '/keywords/activitys',
        title: '活动页管理',
      },
      {
        key: '/keywords/platforms',
        title: '平台产品列表',
      },
      {
        key: '/keywords/members',
        title: '会员管理',
      },
      {
        key: '/keywords/invitations',
        title: '裂变活动',
      },
      {
        key: '/keywords/baidu',
        title: '百度网盘官方数据',
      },
      {
        key: '/keywords/equity',
        title: '百度站长发放权益',
      },
      {
        key: '/keywords/uk',
        title: 'UK上下级',
      },
    ]
  },
  {
    key: 'cpe',
    title: 'CPE管理',
    children: [
      {
        key: '/keywords/cpe/project',
        title: 'CPE项目管理',
      },
      {
        key: '/keywords/cpe/bloggers',
        title: 'CPE博主管理',
      },
      {
        key: '/keywords/cpe/directors',
        title: 'CPE商务管理',
      },
      {
        key: '/keywords/cpe/cpeAccounts',
        title: '账号管理',
      },
      {
        key: '/keywords/cpe/accountReport',
        title: '账号报备管理',
      },
      {
        key: '/keywords/cpe/material',
        title: '素材管理',
      },
      {
        key: '/keywords/cpe/works',
        title: '作品管理',
      },
      {
        key: '/keywords/cpe/credentials',
        title: '凭证管理',
      },
      {
        key: '/keywords/cpe/cpe_works_data',
        title: 'CPE作品数据统计',
      },
      {
        key: '/keywords/cpe/cpe_tags',
        title: 'CPE标签管理',
      },
    ]
  },
  {
    key: 'cpe_budgets',
    title: 'CPE结算管理',
    children: [
      {
        key: '/keywords/cpe_budgets/budgets',
        title: '项目预算',
      },
      {
        key: '/keywords/cpe_budgets/cpe_settlement_rule',
        title: '结算规则',
      },
      {
        key: '/keywords/cpe_budgets/cpe_settlement_datas',
        title: '结算数据',
      },
    ]
  },
  {
    key: 'payment',
    title: '付款管理',
    children: [
      {
        key: '/keywords/bank_cards',
        title: '收款信息',
      },
      {
        key: '/keywords/payment_platforms',
        title: '税源地配置',
      },
      {
        key: '/keywords/payment_signs',
        title: '用户签约状态',
      },
      {
        key: '/keywords/incomes_apply',
        title: '收入申请',
      },
      {
        key: '/keywords/incomes_detail',
        title: '收入明细',
      },
      {
        key: '/keywords/payment_batches',
        title: '付款批次',
      },
      {
        key: '/keywords/payment_detail',
        title: '付款明细',
      },
    ]
  }, 
  {
    key: 'keywords',
    title: '关键词信息管理',
    children: [
      {
        key: '/keywords/manage',
        title: '关键词列表',
      },
      {
        key: '/keywords/apply',
        title: '关键词申请',
      },
      {
        key: '/keywords/stores',
        title: '关键词库',
      },
    ]
  }, 
  {
    key: 'settlement',
    title: '结算管理',
    children: [
      {
        key: '/keywords/settlement_rules',
        title: '结算规则',
      },
      {
        key: '/keywords/settlement_profit',
        title: '投放数据管理',
      },
      {
        key: '/keywords/settlement_activity',
        title: '活动数据管理',
      },
    ]
  }, 
  {
    key: 'koc',
    title: 'KOC管理',
    children: [
      {
        key: '/keywords/koc_account',
        title: '账号管理',
      },
      {
        key: '/keywords/douyin_datas',
        title: '抖音数据报表',
      },
    ]
  }, 
  {
    key: 'stats',
    title: '数据统计',
    children: [
      {
        key: '/keywords/stats_keyword',
        title: '关键词每日统计',
      },
      {
        key: '/keywords/stats_keyword_sum',
        title: '关键词累计数据',
      },
      {
        key: '/keywords/stats_data_blogger',
        title: '博主数据统计',
      },
      {
        key: '/keywords/stats_data_director_daily',
        title: '商务每日统计',
      },
      {
        key: '/keywords/stats_data_director',
        title: '商务数据统计',
      },
      {
        key: '/keywords/stats_data_director_manager',
        title: '商务主管数据统计',
      },
      {
        key: '/keywords/stats_newer_platform',
        title: '平台拉新每日统计',
      },
      {
        key: '/keywords/stats_newer_platform_sum',
        title: '平台拉新汇总统计',
      },
      {
        key: '/keywords/coreboard',
        title: '核心指标看板',
      },
      {
        key: '/keywords/stats_data_upload',
        title: '数据上传',
      },
      {
        key: '/keywords/operate_record',
        title: '操作记录',
      },
    ]
  }, 
  {
    key: 'relatives-director',
    title: '团长关系管理',
    children: [
      {
        key: '/keywords/director_core/director_set',
        title: '核心团长管理',
      },
      {
        key: '/keywords/director_core/director',
        title: '团长汇总数据',
      },
      {
        key: '/keywords/director_core/stats',
        title: '拉新汇总数据',
      },
      {
        key: '/keywords/director_core/blogger',
        title: '博主明细数据',
      },
    ]
  }, 
  {
    key: 'relatives-leader',
    title: '主管关系管理',
    children: [
      {
        key: '/keywords/manager_leader/leader_set',
        title: '商务主管Leader管理',
      },
      {
        key: '/keywords/manager_leader/bound',
        title: '配置主管关系',
      },
      {
        key: '/keywords/manager_leader/summary',
        title: '主管汇总数据',
      },
      {
        key: '/keywords/manager_leader/director',
        title: '团长明细数据',
      },
    ]
  }, 
  {
    key: 'resources',
    title: '悬赏资源管理',
    children: [
      {
        key: '/keywords/resources/manage',
        title: '悬赏资源管理',
      },
      {
        key: '/keywords/resources/pkgs',
        title: '悬赏资源包管理',
      },
      {
        key: '/keywords/resources/links',
        title: '悬赏链接审核',
      },
    ]
  }, 
  {
    key: 'task',
    title: '任务中心',
    children: [
      {
        key: '/keywords/taskcenter',
        title: '任务中心',
      },
    ]
  }, 
  {
    key: 'notification',
    title: '通知消息',
    children: [
      {
        key: '/keywords/notification',
        title: '消息列表',
      },
      {
        key: '/keywords/op_notification',
        title: '通知发布',
      },
    ]
  }, 
]